import { getLink, getButton } from '../dashboardCommon/utils';
import { orderStatus, fmFilterStatuses } from '../../utils/constant';
import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const getStatus = order => {
  const local = useLocaleContext();

  const {
    dashboardVUL: { status }
  } = local === 'en-US' ? EN : FR;
  // order = 'SUBMITTED'
  const incomplete = order === orderStatus.incomplete;
  const completed = order === orderStatus.submitted;
  const orderCanceled = order === orderStatus.canceled;

  const statusList = {
    [incomplete]: status.orderIncomplete,
    [completed]: status.orderCompleted,
    [orderCanceled]: status.orderCanceled
  };

  return statusList.true;
};

const exactCompareArray = (arrOne, arrTwo) => {
  return (
    arrOne.length === arrTwo.length &&
    arrOne.filter((currVal, idx) => currVal !== arrTwo[idx]).length === 0
  );
};

const getOrderType = (productSelected = []) => {
  const local = useLocaleContext();
  const {
    dashboardVUL: {
      microsoftLicensingFM,
      managedItServicesFM,
      managedDetectionResponseFM,
      fmITMDR,
      fmITLicensing,
      fmProducts,
      orderType
    }
  } = local === 'en-US' ? EN : FR;
  let type = '';
  if (exactCompareArray(fmProducts, productSelected)) {
    type = orderType.fmProducts;
  } else if (exactCompareArray(microsoftLicensingFM, productSelected)) {
    type = orderType.microsoftLicensingFM;
  } else if (exactCompareArray(managedItServicesFM, productSelected)) {
    type = orderType.managedItServicesFM;
  } else if (exactCompareArray(managedDetectionResponseFM, productSelected)) {
    type = orderType.managedDetectionResponseFM;
  }
  else if (exactCompareArray(fmITMDR, productSelected)) {
    type = orderType.fmITMDR;
  }
  else if (exactCompareArray(fmITLicensing, productSelected)) {
    type = orderType.fmITLicensing;
  }
   else {
    type = productSelected ? productSelected.join(', ') : '';
  }
  return type;
};

const filterValueToStatusesMap = {
  [fmFilterStatuses.incomplete]: {
    orderStatus: orderStatus.incomplete
  },
  [fmFilterStatuses.submitted]: {
    orderStatus: orderStatus.submitted
  },
  [fmFilterStatuses.orderCanceled]: {
    orderStatus: orderStatus.canceled
  }
};

const getStatusFiltersPayload = filters => {
  const statuses = [];
  filters.forEach(element => {
    if (filterValueToStatusesMap[element.value]) {
      const correspondingOrderStatus =
        filterValueToStatusesMap[element.value].orderStatus;

      if (
        correspondingOrderStatus &&
        !statuses.includes(correspondingOrderStatus)
      )
        statuses.push(correspondingOrderStatus);
    }
  });
  return { status: statuses };
};

export { getLink, getButton, getStatus, getOrderType, getStatusFiltersPayload };
